import React, { Component } from 'react';
import { withFormsy } from 'formsy-react';
import './DGSelect.less';

export class DGSelect extends Component {

    onChange = (event, data) => {
        var index = event.nativeEvent.target.selectedIndex;
        const selectedText = event.nativeEvent.target[index].text;
        this.props.setValue(event.currentTarget.value);
        if (this.props.onChange) {
            this.props.onChange(event, { text: selectedText, value: event.currentTarget.value });
        }
    };

    render() {
        let inputClassName = 'dgselect';
        let labelClassName = 'label';
        if (this.props.icon) {
            inputClassName += ' icon';
            labelClassName += ' icon';
        }
        if ((!this.props.isValid && !this.props.isPristine && this.props.isFormSubmitted) || (this.props.validExternally === false)) {
            inputClassName += ' error';
        }
        return (
            <div className="dropdown-field">
                <select tabIndex={this.props.tabIndex} className="dgselect" onChange={this.onChange}>
                    {this.props.items.map((item) => {
                        return <option value={item.id} selected={this.props.value === item.id} >{item.value}</option>
                    })
                    }
                </select>
                
                <div className={labelClassName}><span>{this.props.label}</span>
                    {this.props.placeholder && <span> ({this.props.placeholder})</span>}
                    {!this.props.placeholder && <span></span>}
                </div>
                {((!this.props.isValid && !this.props.isPristine && this.props.isFormSubmitted) || (this.props.validExternally === false)) && <div className="error-label">{this.props.errorMessage || this.props.externalErrorMessage}</div>}
                {this.props.showRequired &&
                    <div className="required">*</div>
                }

                {this.props.showLoader &&
                    <div className="loader"><img src={loader}></img></div>
                }
            </div>
        )
    }
}

export default  withFormsy(DGSelect)
